<template>
    <app-content-admin>
        <template slot="header">Add Subscriber</template>
               
        <v-layout row wrap>

<v-flex xs12 lg6 mx-auto>
    <v-card>
        <v-card-text>           
            <v-container fluid grid-list-xs>
                <v-layout wrap>

                    <v-flex xs12>
                        <!-- <v-select
                            :items="project_list"
                            :item-text="'project_name'"
                            :item-value="'project_id'"
                            :label="$t('Project')"
                            v-model="form.id_project"
                            :rules="[rules.required('Project')]"
                            outlined
                        ></v-select> -->
                        <v-text-field
      v-model="form.id_project"
      :label="$t('Projects')"
      :rules="[
        value => !!value || 'Project is required',
        value => /^[0-9]+$/.test(value) || 'Project must be a number'
      ]"
      outlined
    ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field
                            :label="$t('First Name')"
                            v-model="form.firstname"
                            :rules="[rules.required('first name')]"
                            outlined
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field
                            :label="$t('Last Name')"
                            v-model="form.lastname"
                            :rules="[rules.required('Last Name')]"
                            outlined
                        >
                        </v-text-field>
                    </v-flex>

                     <v-flex xs12>
                        <v-text-field
                            :label="$t('Email')"
                            v-model="form.email"
                            :rules="[rules.required('Email')]"
                            outlined
                        >
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12>
                        <v-text-field
                            :label="$t('Password')"
                            v-model="form.password"
                            :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required('Password')]"
                            :type="showpass ? 'text' : 'password'"
                            outlined
                            @click:append="showpass = !showpass"
                        > </v-text-field>
                    </v-flex>

                     <v-flex xs12>
                        <v-select
                            :label="$t('Role')"
                            v-model="form.roles"
                            :rules="[rules.required('Role')]"
                             :items="[
                                'admin',
                                'user',
                            ]"
                            outlined
                        ></v-select>
                    </v-flex>


                </v-layout>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="createUser"
                class="form-submit"
            >
                Submit
            </v-btn>
        </v-card-actions>
    </v-card>

</v-flex>

</v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from '../../components/status/ActiveLabel.vue';
import store from '@/store'


export default {
    mixins: [vForm],

    data(){
        return {     
            project_list: [],
            form: {
               
                firstname: null,
                lastname: null,
                email: null,
                password:null,
                id_project:null,
                roles:null,
            },
            showpass: false,                    
          }
        },

        components: {ActiveLabel},

        created() {

            let loader = this.$loading.show();

            let token = store.getters["auth/token"];
            axios
            .get(`/api/cloud/get_firebase_project_list?token=${token}`)
            .then((res) => res.data)
            .then((res) => {
                this.project_list = res.data.result.map((item) => {
                    return {
                        project_id: item.id_project,
                        project_name: item.firebase_project_name,
                    };
                });
            })
            .catch((err) => {
                this.$toastr.e(err.response.data.message);
            })
            .finally(() => {
                loader.hide();
            });
        },

        methods: {
            async createUser(){
                let loader = this.$loading.show();
                try{
                let token = store.getters['auth/token'];
                let res = await axios.post(`/api/auth/create_firebase_user?token=${token}`,this.form)
                     if(res.status == 200){
                        this.$toastr.s('Firebase User created successfully');  
                    }
                }
                catch(err){
                    this.$toastr.e(err.response.data.message);
                }
                finally{
                    loader.hide();                  
                }
            },

            async uploadJSON(){
                var formData = new FormData();
                formData.append('firebase_service_account',this.jsonFile)
                try{
                let token = store.getters['auth/token'];
                const config = {
                   headers:{
                       'Content-Type' : 'multipart/form-data',
                   }
                 };
                let res = await axios.post(`/api/cloud/upload_json?token=${token}`,formData, config)
                return res.data.data.path                   
                }
                catch(err){
                    this.$toastr.e(err.response.data.message);
                }                
            },
            fileChange(e){
                this.jsonFile = e;
            },         

        }
}
</script>